
/**
 * Module dependencies.
 */

import { useRouter } from 'next/router';

/**
 * Export `useDateFormatter`.
 */

export function useDateFormatter() {
  const { locale } = useRouter();

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}
